<form class="tp-form rp-form" [formGroup]="reportForm">
    <div class="tp-form__section">
      <div class="tp-form__grid">
        <div class="tp-form__field">
          <label class="tp-form__label" for="fromDate">Desde</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input id="fromDate" matInput placeholder="dd/mm/aaaa" [matDatepicker]="pickerFrom" formControlName="fromDate" required />
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="tp-form__field">
          <label class="tp-form__label" for="toDate">Hasta</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input id="toDate" matInput placeholder="dd/mm/aaaa" [matDatepicker]="pickerTo" formControlName="toDate" required />
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="tp-form__field tp-form__field--full">
          <span class="tp-form__label">Opciones de descarga</span>
          <mat-checkbox formControlName="taskUnassigned" (change)="onCheckboxChange($event)">Incluir tareas sin agendar</mat-checkbox>
        </div>
      </div>
    </div>

    <div class="rp-actions">
      <button mat-flat-button [disabled]="isLoading" (click)="onSubmit()">
        @if (!isLoading) {
          <span>Descargar reporte</span>
        } @else {
          <mat-spinner class="rp-spinner" diameter="20" strokeWidth="3"></mat-spinner>
          <span>Descargando...</span>
        }
      </button>
    </div>
  </form>
